<template>
  <user-table :company-id="companyId" class="mt-3" />
</template>
<script>
import UserTable from '../../../../../components/UserTable.vue';

export default {
  name: 'company_user_list',
  components: {
    UserTable,
  },
  computed: {
    companyId() {
      return this.$route.params.companyId;
    },
  },
  created() {
    this.$store.dispatch('companies/LOAD_DETAIL_DATA');
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/admin/companies/detail/Users.vue